import React from 'react'

export default ({ icon, color, stroke }) => {
  switch (icon) {
    case 'eyeShow':
      return <EyeShow />
    case 'eyeHide':
      return <EyeHide />
    case 'settings':
      return <Settings />
    case 'home':
      return <Home />
    case 'search':
      return <Search />
    case 'library':
      return <Library />
    case 'notifications':
      return <Notifications />
    case 'messages':
      return <Messages />
    case 'menu':
      return <Menu />
    case 'list':
      return <List />
    case 'edit':
      return <Edit />
    case 'delete':
      return <Delete />
    case 'activate':
      return <Activate />
    case 'exclamation':
      return <Exclamation />
    case 'dismissFilled':
      return <DismissFilled />
    case 'checkbox':
      return <Checkbox />
    case 'checkboxChecked':
      return <CheckboxChecked />
    case 'close':
      return <Close />
    case 'userRegister':
      return <UserRegister />
    case 'link':
      return <Link />
    case 'dashboard':
      return <Dashboard />
    case 'check':
      return <Check color={color}/>
    case 'info':
      return <Info color={color}/>
    case 'infoHollow':
      return <InfoHollow />
    case 'error':
      return <Error color={color}/>
    case 'errorHollow':
      return <ErrorHollow />
    case 'camera':
      return <Camera />
    case 'cameraOff':
      return <CameraOff />
    case 'light':
      return <Light />
    case 'bigCheck':
      return <BigCheck />
    case 'bigClose':
      return <BigClose />
    default:
      return null
  }
}

const EyeShow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 9.00462C14.2091 9.00462 16 10.7955 16 13.0046C16 15.2138 14.2091 17.0046 12 17.0046C9.79086 17.0046 8 15.2138 8 13.0046C8 10.7955 9.79086 9.00462 12 9.00462ZM12 10.5046C10.6193 10.5046 9.5 11.6239 9.5 13.0046C9.5 14.3853 10.6193 15.5046 12 15.5046C13.3807 15.5046 14.5 14.3853 14.5 13.0046C14.5 11.6239 13.3807 10.5046 12 10.5046ZM12 5.5C16.6135 5.5 20.5961 8.65001 21.7011 13.0644C21.8017 13.4662 21.5575 13.8735 21.1557 13.9741C20.7539 14.0746 20.3466 13.8305 20.246 13.4286C19.3071 9.67796 15.9214 7 12 7C8.07693 7 4.69009 9.68026 3.75285 13.4332C3.65249 13.835 3.24535 14.0794 2.84348 13.9791C2.44161 13.8787 2.19719 13.4716 2.29755 13.0697C3.40064 8.65272 7.38448 5.5 12 5.5Z"
      fill="currentColor"
    />
  </svg>
)

const EyeHide = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7803 2.21967C22.0466 2.48594 22.0708 2.9026 21.8529 3.19621L21.7803 3.28033L17.7458 7.3149C19.6678 8.66437 21.1042 10.6799 21.7011 13.0644C21.8017 13.4662 21.5575 13.8735 21.1557 13.9741C20.7539 14.0746 20.3466 13.8305 20.246 13.4286C19.7165 11.3135 18.4089 9.53947 16.6658 8.39452L14.8562 10.2043C15.5637 10.9258 16 11.9143 16 13.0046C16 15.2138 14.2091 17.0046 12 17.0046C10.9096 17.0046 9.92116 16.5683 9.19963 15.8608L3.28033 21.7803C2.98744 22.0732 2.51256 22.0732 2.21967 21.7803C1.9534 21.5141 1.9292 21.0974 2.14705 20.8038L2.21967 20.7197L8.33321 14.6055L8.332 14.604L9.53207 13.4061L12.402 10.5368L12.4 10.536L15.2812 7.65782L15.28 7.656L16.4133 6.52549L20.7197 2.21967C21.0126 1.92678 21.4874 1.92678 21.7803 2.21967ZM13.7959 11.2655L10.2608 14.8006C10.7108 15.2364 11.3241 15.5046 12 15.5046C13.3807 15.5046 14.5 14.3853 14.5 13.0046C14.5 12.3287 14.2318 11.7154 13.7959 11.2655ZM12 5.5C13.0003 5.5 13.9709 5.64807 14.8889 5.925L13.6519 7.16119C13.1161 7.05532 12.5636 7 12 7C8.07693 7 4.6901 9.68026 3.75286 13.4332C3.6525 13.835 3.24535 14.0794 2.84348 13.9791C2.44161 13.8787 2.19719 13.4716 2.29755 13.0697C3.40065 8.65272 7.38448 5.5 12 5.5ZM11.8053 9.00928L8.004 12.81C8.10575 10.7531 9.75276 9.10764 11.8053 9.00928Z"
      fill="currentColor"
    />
  </svg>
)

const Settings = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0125 2.25006C12.7465 2.25852 13.4776 2.34332 14.194 2.5031C14.5067 2.57285 14.7406 2.83357 14.7761 3.15202L14.9463 4.67887C15.0234 5.37992 15.6153 5.9109 16.3209 5.91164C16.5106 5.91194 16.6982 5.87244 16.8735 5.79489L18.2741 5.17962C18.5654 5.05165 18.9058 5.12142 19.1232 5.35368C20.1354 6.4347 20.8892 7.73121 21.328 9.14564C21.4226 9.45064 21.3137 9.78209 21.0567 9.97156L19.8152 10.8867C19.461 11.1469 19.2519 11.5601 19.2519 11.9995C19.2519 12.439 19.461 12.8522 19.816 13.113L21.0585 14.0284C21.3157 14.2178 21.4246 14.5493 21.33 14.8544C20.8914 16.2685 20.138 17.565 19.1264 18.6462C18.9092 18.8784 18.5691 18.9483 18.2778 18.8207L16.8715 18.2046C16.4691 18.0285 16.0071 18.0543 15.6268 18.274C15.2466 18.4938 14.9936 18.8813 14.9453 19.3178L14.7762 20.8445C14.7413 21.1593 14.5125 21.4182 14.2043 21.4916C12.7559 21.8362 11.2468 21.8362 9.79834 21.4916C9.49021 21.4182 9.26135 21.1593 9.22649 20.8445L9.05767 19.32C9.00808 18.8843 8.75465 18.498 8.37473 18.279C7.99481 18.06 7.53351 18.0344 7.13251 18.2094L5.72588 18.8257C5.43453 18.9534 5.09434 18.8833 4.87709 18.651C3.86493 17.5685 3.1115 16.2706 2.67351 14.8549C2.57917 14.5499 2.68817 14.2187 2.94515 14.0294L4.18848 13.1134C4.54262 12.8532 4.75178 12.44 4.75178 12.0005C4.75178 11.5611 4.54262 11.1479 4.18802 10.8873L2.94547 9.97291C2.6881 9.78351 2.579 9.45184 2.67367 9.14664C3.11242 7.73221 3.86625 6.4357 4.87843 5.35468C5.0959 5.12242 5.43624 5.05265 5.72755 5.18062L7.12793 5.79579C7.53087 5.97262 7.99411 5.94591 8.37608 5.72275C8.7564 5.50215 9.00959 5.11428 9.05847 4.6777L9.22855 3.15202C9.26407 2.83341 9.49817 2.5726 9.81111 2.503C10.5284 2.34348 11.2603 2.25871 12.0125 2.25006ZM12.0127 3.74996C11.5586 3.75531 11.1059 3.79449 10.6581 3.86708L10.5492 4.84425C10.4474 5.75374 9.92034 6.56108 9.13072 7.01909C8.33628 7.48323 7.36767 7.53909 6.52489 7.16923L5.6266 6.77462C5.05467 7.46879 4.59945 8.25141 4.27883 9.09174L5.07662 9.67885C5.81543 10.2217 6.25178 11.0837 6.25178 12.0005C6.25178 12.9173 5.81543 13.7794 5.0774 14.3216L4.27835 14.9103C4.59869 15.7521 5.05398 16.5362 5.62631 17.2317L6.53144 16.8351C7.36953 16.4692 8.33155 16.5228 9.12383 16.9795C9.91612 17.4362 10.4446 18.2418 10.5483 19.1527L10.6573 20.1366C11.5469 20.2878 12.4558 20.2878 13.3454 20.1366L13.4544 19.1527C13.5552 18.2421 14.0831 17.4337 14.8763 16.9753C15.6695 16.5169 16.6335 16.4631 17.4731 16.8305L18.3775 17.2268C18.9493 16.5323 19.4044 15.7495 19.725 14.909L18.927 14.3212C18.1882 13.7784 17.7519 12.9163 17.7519 11.9995C17.7519 11.0827 18.1882 10.2207 18.9261 9.67853L19.723 9.09116C19.4024 8.25067 18.9471 7.4679 18.3751 6.77362L17.4786 7.16743C17.1133 7.32907 16.7181 7.41227 16.319 7.41164C14.8493 7.4101 13.6158 6.30361 13.4554 4.84389L13.3465 3.86676C12.901 3.79426 12.4529 3.75518 12.0127 3.74996ZM12 8.25001C14.0711 8.25001 15.75 9.92894 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12C8.25 9.92894 9.92893 8.25001 12 8.25001ZM12 9.75001C10.7574 9.75001 9.75 10.7574 9.75 12C9.75 13.2427 10.7574 14.25 12 14.25C13.2426 14.25 14.25 13.2427 14.25 12C14.25 10.7574 13.2426 9.75001 12 9.75001Z"
      fill="currentColor"
    />
  </svg>
)

const Home = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5358 2.91088C11.8081 2.69637 12.1919 2.69637 12.4642 2.91088L19.5708 8.51003C20.4733 9.2211 21 10.3067 21 11.4556V20.75C21 21.4404 20.4404 22 19.75 22H14.75C14.0596 22 13.5 21.4404 13.5 20.75V15.75C13.5 15.6119 13.3881 15.5 13.25 15.5H10.75C10.6119 15.5 10.5 15.6119 10.5 15.75V20.75C10.5 21.4404 9.94036 22 9.25 22H4.25C3.55964 22 3 21.4404 3 20.75V11.4556C3 10.3067 3.52672 9.2211 4.42923 8.51003L11.5358 2.91088ZM12 4.45482L5.35754 9.68827C4.81603 10.1149 4.5 10.7662 4.5 11.4556V20.5H9V15.75C9 14.7835 9.7835 14 10.75 14H13.25C14.2165 14 15 14.7835 15 15.75V20.5H19.5V11.4556C19.5 10.7662 19.184 10.1149 18.6425 9.68827L12 4.45482Z"
      fill="currentColor"
    />
  </svg>
)

const Search = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2.75C14.0041 2.75 17.25 5.99594 17.25 10C17.25 11.7319 16.6427 13.3219 15.6295 14.5688L20.5303 19.4697C20.8232 19.7626 20.8232 20.2374 20.5303 20.5303C20.2641 20.7966 19.8474 20.8208 19.5538 20.6029L19.4697 20.5303L14.5688 15.6295C13.3219 16.6427 11.7319 17.25 10 17.25C5.99594 17.25 2.75 14.0041 2.75 10C2.75 5.99594 5.99594 2.75 10 2.75ZM10 4.25C6.82436 4.25 4.25 6.82436 4.25 10C4.25 13.1756 6.82436 15.75 10 15.75C13.1756 15.75 15.75 13.1756 15.75 10C15.75 6.82436 13.1756 4.25 10 4.25Z"
      fill="currentColor"
    />
  </svg>
)

const Library = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.19053 21.8539C5.69439 22.2109 5.00252 21.8563 5.00252 21.2451V6.24918C5.00252 4.45425 6.45759 2.99918 8.25252 2.99918H15.7509C17.5458 2.99918 19.0009 4.45425 19.0009 6.24918V21.2451C19.0009 21.8563 18.309 22.2109 17.8129 21.8539L12.0017 17.673L6.19053 21.8539ZM17.5009 6.24918C17.5009 5.28268 16.7174 4.49918 15.7509 4.49918H8.25252C7.28602 4.49918 6.50252 5.28268 6.50252 6.24918V19.7816L11.5637 16.1402C11.8254 15.952 12.1781 15.952 12.4397 16.1402L17.5009 19.7816V6.24918Z"
      fill="currentColor"
    />
  </svg>
)

const Notifications = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.99622C16.0499 1.99622 19.3567 5.19096 19.4958 9.24527L19.5 9.49622V13.5932L20.88 16.7492C20.9491 16.9071 20.9847 17.0776 20.9847 17.25C20.9847 17.9403 20.4251 18.5 19.7347 18.5L15 18.5015C15 20.1583 13.6569 21.5015 12 21.5015C10.4023 21.5015 9.09634 20.2526 9.0051 18.6778L8.99955 18.4992L4.27487 18.5C4.10353 18.5 3.93402 18.4648 3.77687 18.3965C3.14366 18.1215 2.85332 17.3852 3.12836 16.752L4.5 13.5941V9.49611C4.5006 5.34132 7.85209 1.99622 12 1.99622ZM13.4996 18.4992L10.5 18.5015C10.5 19.3299 11.1716 20.0015 12 20.0015C12.7797 20.0015 13.4205 19.4066 13.4931 18.6459L13.4996 18.4992ZM12 3.49622C8.67984 3.49622 6.00048 6.17047 6 9.49622V13.9058L4.65602 17H19.3525L18 13.9068L18.0001 9.50907L17.9964 9.28387C17.8853 6.0504 15.2416 3.49622 12 3.49622Z"
      fill="currentColor"
    />
  </svg>
)

const Messages = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 18C3.45507 18 2 16.5449 2 14.75V6.25C2 4.45507 3.45507 3 5.25 3H18.75C20.5449 3 22 4.45507 22 6.25V14.75C22 16.5449 20.5449 18 18.75 18H13.0125L7.99868 21.7507C7.44585 22.1642 6.6625 22.0512 6.24901 21.4984C6.08736 21.2822 6 21.0196 6 20.7499L5.99921 18H5.25ZM12.5135 16.5H18.75C19.7165 16.5 20.5 15.7165 20.5 14.75V6.25C20.5 5.2835 19.7165 4.5 18.75 4.5H5.25C4.2835 4.5 3.5 5.2835 3.5 6.25V14.75C3.5 15.7165 4.2835 16.5 5.25 16.5H7.49879L7.499 17.2498L7.49986 20.2506L12.5135 16.5Z"
      fill="currentColor"
    />
  </svg>
)

const Menu = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3757 12C10.3757 11.1029 11.1029 10.3757 12 10.3757C12.897 10.3757 13.6243 11.1029 13.6243 12C13.6243 12.897 12.897 13.6243 12 13.6243C11.1029 13.6243 10.3757 12.897 10.3757 12ZM10.3757 5.99999C10.3757 5.10294 11.1029 4.37573 12 4.37573C12.897 4.37573 13.6243 5.10294 13.6243 5.99999C13.6243 6.89705 12.897 7.62426 12 7.62426C11.1029 7.62426 10.3757 6.89705 10.3757 5.99999ZM10.3757 18C10.3757 17.1029 11.1029 16.3757 12 16.3757C12.897 16.3757 13.6243 17.1029 13.6243 18C13.6243 18.897 12.897 19.6243 12 19.6243C11.1029 19.6243 10.3757 18.897 10.3757 18Z"
      fill="currentColor"
    />
  </svg>
)

const List = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 18H15.25C15.6642 18 16 18.3358 16 18.75C16 19.1297 15.7178 19.4435 15.3518 19.4931L15.25 19.5H2.75C2.33579 19.5 2 19.1642 2 18.75C2 18.3703 2.28215 18.0565 2.64823 18.0068L2.75 18H15.25H2.75ZM2.75 11.5H21.25C21.6642 11.5 22 11.8358 22 12.25C22 12.6297 21.7178 12.9435 21.3518 12.9931L21.25 13H2.75C2.33579 13 2 12.6642 2 12.25C2 11.8703 2.28215 11.5565 2.64823 11.5068L2.75 11.5H21.25H2.75ZM2.75 5.00323H18.25C18.6642 5.00323 19 5.33902 19 5.75323C19 6.13293 18.7178 6.44673 18.3518 6.49639L18.25 6.50323H2.75C2.33579 6.50323 2 6.16745 2 5.75323C2 5.37354 2.28215 5.05974 2.64823 5.01008L2.75 5.00323H18.25H2.75Z"
      fill="currentColor"
    />
  </svg>
)

const Edit = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0303 2.96967C22.4278 4.36713 22.4278 6.63286 21.0303 8.03033L9.06201 19.9987C8.78513 20.2755 8.4408 20.4754 8.06303 20.5784L2.94734 21.9736C2.38747 22.1263 1.87374 21.6125 2.02643 21.0527L3.42162 15.937C3.52465 15.5592 3.72447 15.2149 4.00135 14.938L15.9697 2.96967C17.3671 1.5722 19.6329 1.5722 21.0303 2.96967ZM15.0002 6.06057L5.06201 15.9987C4.96972 16.0909 4.90311 16.2057 4.86877 16.3316L3.81892 20.1811L7.66836 19.1312C7.79428 19.0969 7.90906 19.0303 8.00135 18.938L17.9392 8.99957L15.0002 6.06057ZM17.0303 4.03033L16.0602 4.99957L18.9992 7.93957L19.9697 6.96967C20.7813 6.15799 20.7813 4.842 19.9697 4.03033C19.158 3.21865 17.842 3.21865 17.0303 4.03033Z"
      fill="currentColor"
    />
  </svg>
)

const Delete = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.75C13.733 1.75 15.1492 3.10645 15.2449 4.81558L15.25 5H20.5C20.9142 5 21.25 5.33579 21.25 5.75C21.25 6.1297 20.9678 6.44349 20.6018 6.49315L20.5 6.5H19.704L18.4239 19.5192C18.2912 20.8683 17.1984 21.91 15.8626 21.9945L15.6871 22H8.31293C6.95734 22 5.81365 21.0145 5.59883 19.6934L5.57614 19.5192L4.295 6.5H3.5C3.1203 6.5 2.80651 6.21785 2.75685 5.85177L2.75 5.75C2.75 5.3703 3.03215 5.05651 3.39823 5.00685L3.5 5H8.75C8.75 3.20507 10.2051 1.75 12 1.75ZM18.197 6.5H5.802L7.06893 19.3724C7.12768 19.9696 7.60033 20.4343 8.18585 20.4936L8.31293 20.5H15.6871C16.2872 20.5 16.7959 20.0751 16.9123 19.4982L16.9311 19.3724L18.197 6.5ZM13.75 9.25C14.1297 9.25 14.4435 9.53215 14.4932 9.89823L14.5 10V17C14.5 17.4142 14.1642 17.75 13.75 17.75C13.3703 17.75 13.0565 17.4678 13.0068 17.1018L13 17V10C13 9.58579 13.3358 9.25 13.75 9.25ZM10.25 9.25C10.6297 9.25 10.9435 9.53215 10.9932 9.89823L11 10V17C11 17.4142 10.6642 17.75 10.25 17.75C9.8703 17.75 9.55651 17.4678 9.50685 17.1018L9.5 17V10C9.5 9.58579 9.83579 9.25 10.25 9.25ZM12 3.25C11.0818 3.25 10.3288 3.95711 10.2558 4.85647L10.25 5H13.75C13.75 4.0335 12.9665 3.25 12 3.25Z"
      fill="currentColor"
    />
  </svg>
)

const Activate = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.2042 4.82022C8.57962 4.64521 9.02584 4.80767 9.20085 5.1831C9.37586 5.55852 9.2134 6.00474 8.83797 6.17975C6.21382 7.40306 4.5 10.0413 4.5 12.9911C4.5 17.1384 7.85759 20.5 11.9989 20.5C16.1403 20.5 19.4979 17.1384 19.4979 12.9911C19.4979 10.0474 17.7912 7.41365 15.1753 6.18693C14.8002 6.01107 14.6388 5.56448 14.8147 5.18946C14.9905 4.81443 15.4371 4.65298 15.8121 4.82885C18.9502 6.30041 20.9979 9.46042 20.9979 12.9911C20.9979 17.9664 16.9691 22 11.9989 22C7.02876 22 3 17.9664 3 12.9911C3 9.45309 5.05623 6.28771 8.2042 4.82022ZM11.9989 2.49585C12.3786 2.49585 12.6924 2.778 12.7421 3.14408L12.7489 3.24585V10.7458C12.7489 11.16 12.4132 11.4958 11.9989 11.4958C11.6192 11.4958 11.3055 11.2136 11.2558 10.8476L11.2489 10.7458V3.24585C11.2489 2.83164 11.5847 2.49585 11.9989 2.49585Z"
      fill="currentColor"
    />
  </svg>
)

const Exclamation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12" y2="16"></line>
  </svg>
)

const DismissFilled = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.5303 8.46967L15.4462 8.39705C15.1852 8.2034 14.827 8.20101 14.5636 8.38988L14.4697 8.46967L12 10.939L9.53033 8.46967L9.44621 8.39705C9.18522 8.2034 8.82701 8.20101 8.56362 8.38988L8.46967 8.46967L8.39705 8.55379C8.2034 8.81478 8.20101 9.17299 8.38988 9.43638L8.46967 9.53033L10.939 12L8.46967 14.4697L8.39705 14.5538C8.2034 14.8148 8.20101 15.173 8.38988 15.4364L8.46967 15.5303L8.55379 15.6029C8.81478 15.7966 9.17299 15.799 9.43638 15.6101L9.53033 15.5303L12 13.061L14.4697 15.5303L14.5538 15.6029C14.8148 15.7966 15.173 15.799 15.4364 15.6101L15.5303 15.5303L15.6029 15.4462C15.7966 15.1852 15.799 14.827 15.6101 14.5636L15.5303 14.4697L13.061 12L15.5303 9.53033L15.6029 9.44621C15.7966 9.18522 15.799 8.82701 15.6101 8.56362L15.5303 8.46967L15.4462 8.39705L15.5303 8.46967Z"
      fill="currentColor"
    />
  </svg>
)

const Checkbox = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 3H18.25C19.7688 3 21 4.23122 21 5.75V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75C3 4.23122 4.23122 3 5.75 3ZM5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V5.75C19.5 5.05964 18.9404 4.5 18.25 4.5H5.75Z"
      fill="currentColor"
    />
  </svg>
)

const CheckboxChecked = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.25 3C19.7688 3 21 4.23122 21 5.75V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75C3 4.23122 4.23122 3 5.75 3H18.25ZM18.25 4.5H5.75C5.05964 4.5 4.5 5.05964 4.5 5.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V5.75C19.5 5.05964 18.9404 4.5 18.25 4.5ZM10 14.4393L16.4697 7.96967C16.7626 7.67678 17.2374 7.67678 17.5303 7.96967C17.7966 8.23594 17.8208 8.6526 17.6029 8.94621L17.5303 9.03033L10.5303 16.0303C10.2641 16.2966 9.8474 16.3208 9.55379 16.1029L9.46967 16.0303L6.46967 13.0303C6.17678 12.7374 6.17678 12.2626 6.46967 11.9697C6.73594 11.7034 7.1526 11.6792 7.44621 11.8971L7.53033 11.9697L10 14.4393L16.4697 7.96967L10 14.4393Z"
      fill="currentColor"
    />
  </svg>
)

const Close = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.2097 4.3871L4.29289 4.29289C4.65338 3.93241 5.22061 3.90468 5.6129 4.2097L5.70711 4.29289L12 10.585L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L13.415 12L19.7071 18.2929C20.0676 18.6534 20.0953 19.2206 19.7903 19.6129L19.7071 19.7071C19.3466 20.0676 18.7794 20.0953 18.3871 19.7903L18.2929 19.7071L12 13.415L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L10.585 12L4.29289 5.70711C3.93241 5.34662 3.90468 4.77939 4.2097 4.3871L4.29289 4.29289L4.2097 4.3871Z"
      fill="currentColor"
    />
  </svg>
)

const UserRegister = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7454 4C20.988 4 21.9954 5.00736 21.9954 6.25V17.7546C21.9954 18.9972 20.988 20.0046 19.7454 20.0046H4.25C3.00736 20.0046 2 18.9972 2 17.7546V6.25C2 5.00736 3.00736 4 4.25 4H19.7454ZM19.7454 5.5H4.25C3.83579 5.5 3.5 5.83579 3.5 6.25V17.7546C3.5 18.1688 3.83579 18.5046 4.25 18.5046L6.999 18.504L7 15.75C7 14.8318 7.70711 14.0788 8.60647 14.0058L8.75 14H15.2447C16.1629 14 16.9159 14.7071 16.9889 15.6065L16.9947 15.75L16.994 18.504L19.7454 18.5046C20.1596 18.5046 20.4954 18.1688 20.4954 17.7546V6.25C20.4954 5.83579 20.1596 5.5 19.7454 5.5ZM12 7.00046C13.6569 7.00046 15 8.34361 15 10.0005C15 11.6573 13.6569 13.0005 12 13.0005C10.3431 13.0005 9 11.6573 9 10.0005C9 8.34361 10.3431 7.00046 12 7.00046Z"
      fill="currentColor"
    />
  </svg>
)

const Link = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 7C9.55228 7 10 7.44772 10 8C10 8.51284 9.61396 8.93551 9.11662 8.99327L9 9H7C5.34315 9 4 10.3431 4 12C4 13.5977 5.24892 14.9037 6.82373 14.9949L7 15H9C9.55228 15 10 15.4477 10 16C10 16.5128 9.61396 16.9355 9.11662 16.9933L9 17H7C4.23858 17 2 14.7614 2 12C2 9.31125 4.12231 7.11818 6.78311 7.00462L7 7H9ZM17 7C19.7614 7 22 9.23858 22 12C22 14.6888 19.8777 16.8818 17.2169 16.9954L17 17H15C14.4477 17 14 16.5523 14 16C14 15.4872 14.386 15.0645 14.8834 15.0067L15 15H17C18.6569 15 20 13.6569 20 12C20 10.4023 18.7511 9.09634 17.1763 9.00509L17 9H15C14.4477 9 14 8.55228 14 8C14 7.48716 14.386 7.06449 14.8834 7.00673L15 7H17ZM7 11H17C17.5523 11 18 11.4477 18 12C18 12.5128 17.614 12.9355 17.1166 12.9933L17 13H7C6.44772 13 6 12.5523 6 12C6 11.4872 6.38604 11.0645 6.88338 11.0067L7 11H17H7Z"
      fill="currentColor"
    />
  </svg>
)

const Dashboard = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.75 3C19.5449 3 21 4.45507 21 6.25V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45507 3 6.25 3H17.75ZM19.5 8.5H4.5V17.75C4.5 18.7165 5.2835 19.5 6.25 19.5H17.75C18.7165 19.5 19.5 18.7165 19.5 17.75V8.5ZM17.75 4.5H6.25C5.2835 4.5 4.5 5.2835 4.5 6.25V7H19.5V6.25C19.5 5.2835 18.7165 4.5 17.75 4.5Z"
      fill="currentColor"
    />
  </svg>
)

const Check = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="white" />
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z"
      fill={ color || "#17cf3f" }
    />
  </svg>
)

const Info = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="white" />
    <path
      d="M12 1.99896C17.5237 1.99896 22.0015 6.47681 22.0015 12.0005C22.0015 17.5242 17.5237 22.0021 12 22.0021C6.47629 22.0021 1.99844 17.5242 1.99844 12.0005C1.99844 6.47681 6.47629 1.99896 12 1.99896ZM11.9962 10.2495C11.4834 10.2499 11.0609 10.6362 11.0035 11.1336L10.9968 11.2502L11.0004 16.7518L11.0072 16.8684C11.0653 17.3657 11.4883 17.7515 12.0011 17.7511C12.5139 17.7508 12.9364 17.3645 12.9938 16.8671L13.0004 16.7505L12.9968 11.2489L12.99 11.1323C12.9319 10.635 12.509 10.2492 11.9962 10.2495ZM12.0004 6.49999C11.3092 6.49999 10.7489 7.06032 10.7489 7.75152C10.7489 8.44271 11.3092 9.00304 12.0004 9.00304C12.6916 9.00304 13.252 8.44271 13.252 7.75152C13.252 7.06032 12.6916 6.49999 12.0004 6.49999Z"
      fill={ color || "#fcba03" }
    />
  </svg>
)

const InfoHollow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.99896C17.5237 1.99896 22.0015 6.47681 22.0015 12.0005C22.0015 17.5242 17.5237 22.0021 12 22.0021C6.47629 22.0021 1.99844 17.5242 1.99844 12.0005C1.99844 6.47681 6.47629 1.99896 12 1.99896ZM12 3.49896C7.30472 3.49896 3.49844 7.30524 3.49844 12.0005C3.49844 16.6958 7.30472 20.5021 12 20.5021C16.6953 20.5021 20.5015 16.6958 20.5015 12.0005C20.5015 7.30524 16.6953 3.49896 12 3.49896ZM11.9964 10.4995C12.376 10.4993 12.69 10.7812 12.7399 11.1473L12.7468 11.2491L12.7504 16.7506C12.7507 17.1649 12.4151 17.5009 12.0009 17.5011C11.6212 17.5014 11.3073 17.2194 11.2574 16.8534L11.2504 16.7516L11.2468 11.25C11.2466 10.8358 11.5821 10.4998 11.9964 10.4995ZM12.0004 7.00178C12.552 7.00178 12.9991 7.4489 12.9991 8.00044C12.9991 8.55199 12.552 8.99911 12.0004 8.99911C11.4489 8.99911 11.0018 8.55199 11.0018 8.00044C11.0018 7.4489 11.4489 7.00178 12.0004 7.00178Z"
      fill="currentColor"
    />
  </svg>
)

const Error = ({color}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="white" />
    <path
      d="M19.0711 4.92895C22.9763 8.83419 22.9763 15.1658 19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711C1.02369 15.1658 1.02369 8.83419 4.92893 4.92895C8.83418 1.0237 15.1658 1.0237 19.0711 4.92895ZM15.5355 8.46448C15.267 8.196 14.8456 8.17362 14.5517 8.39736L14.4749 8.46448L12 10.9394L9.52513 8.46448C9.23223 8.17159 8.75736 8.17159 8.46447 8.46448C8.19598 8.73297 8.17361 9.15437 8.39734 9.44834L8.46447 9.52514L10.9393 12L8.46447 14.4749C8.17157 14.7678 8.17157 15.2427 8.46447 15.5355C8.73295 15.804 9.15435 15.8264 9.44832 15.6027L9.52513 15.5355L12 13.0607L14.4749 15.5355C14.7678 15.8284 15.2426 15.8284 15.5355 15.5355C15.804 15.2671 15.8264 14.8457 15.6027 14.5517L15.5355 14.4749L13.0607 12L15.5355 9.52514C15.8284 9.23225 15.8284 8.75737 15.5355 8.46448Z"
      fill={ color || "#e31010" }
    />
  </svg>)

const ErrorHollow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0711 4.92895C22.9763 8.83419 22.9763 15.1658 19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711C1.02369 15.1658 1.02369 8.83419 4.92893 4.92895C8.83418 1.0237 15.1658 1.0237 19.0711 4.92895ZM18.0104 5.98961C14.691 2.67015 9.30905 2.67015 5.98959 5.98961C2.67014 9.30906 2.67014 14.691 5.98959 18.0104C9.30905 21.3299 14.691 21.3299 18.0104 18.0104C21.3299 14.691 21.3299 9.30906 18.0104 5.98961ZM15.5355 8.46448C15.8284 8.75737 15.8284 9.23225 15.5355 9.52514L13.0607 12L15.5355 14.4749C15.8284 14.7678 15.8284 15.2427 15.5355 15.5355C15.2426 15.8284 14.7678 15.8284 14.4749 15.5355L12 13.0607L9.52513 15.5355C9.23223 15.8284 8.75736 15.8284 8.46447 15.5355C8.17157 15.2427 8.17157 14.7678 8.46447 14.4749L10.9393 12L8.46447 9.52514C8.17157 9.23225 8.17157 8.75737 8.46447 8.46448C8.75736 8.17159 9.23223 8.17159 9.52513 8.46448L12 10.9394L14.4749 8.46448C14.7678 8.17159 15.2426 8.17159 15.5355 8.46448Z"
      fill="currentColor"
    />
  </svg>
)

const Camera = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.75 4.5C15.5449 4.5 17 5.95507 17 7.75V7.923L20.8639 5.605C21.3638 5.30486 22 5.66493 22 6.248V17.75C22 18.333 21.364 18.6931 20.8641 18.3931L17 16.075V16.25C17 18.0449 15.5449 19.5 13.75 19.5H5.25C3.45507 19.5 2 18.0449 2 16.25V7.75C2 5.95507 3.45507 4.5 5.25 4.5H13.75ZM13.75 6H5.25C4.2835 6 3.5 6.7835 3.5 7.75V16.25C3.5 17.2165 4.2835 18 5.25 18H13.75C14.7165 18 15.5 17.2165 15.5 16.25V7.75C15.5 6.7835 14.7165 6 13.75 6ZM20.5 7.5731L17 9.6745V14.3254L20.5 16.4254V7.5731Z"
      fill="currentColor"
    />
  </svg>
)

const CameraOff = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7803 2.21967C22.0466 2.48594 22.0708 2.9026 21.8529 3.19621L21.7803 3.28033L17.343 7.717L20.8639 5.605C21.3638 5.30486 22 5.66493 22 6.248V17.75C22 18.333 21.364 18.6931 20.8641 18.3931L17 16.075V16.25C17 18.0449 15.5449 19.5 13.75 19.5H5.56L3.28033 21.7803C3.01406 22.0466 2.5974 22.0708 2.30379 21.8529L2.21967 21.7803C1.9534 21.5141 1.9292 21.0974 2.14705 20.8038L2.21967 20.7197L3.78687 19.1528L3.785 19.151L4.9621 17.9764L15.4764 7.4621L15.476 7.46L16.6528 6.28687L20.7197 2.21967C21.0126 1.92678 21.4874 1.92678 21.7803 2.21967ZM13.75 4.5C14.4729 4.5 15.1406 4.736 15.6804 5.13515L14.5962 6.21781C14.3454 6.07901 14.0569 6 13.75 6H5.25C4.2835 6 3.5 6.7835 3.5 7.75V16.25C3.5 16.5569 3.57901 16.8454 3.71781 17.0962L2.63515 18.1804C2.236 17.6406 2 16.9729 2 16.25V7.75C2 5.95507 3.45507 4.5 5.25 4.5H13.75ZM15.5 9.56L7.06 18H13.75C14.7165 18 15.5 17.2165 15.5 16.25V9.56ZM20.5 7.5731L17 9.6745V14.3254L20.5 16.4254V7.5731Z"
      fill="currentColor"
    />
  </svg>
)

const Light = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.0014C16.0041 2.0014 19.25 5.24734 19.25 9.2514C19.25 11.3475 18.3493 13.2711 16.587 14.9933C16.51 15.0685 16.4504 15.1591 16.4119 15.2586L16.3804 15.3609L15.2493 20.2565C15.0266 21.2204 14.2035 21.9188 13.2303 21.9934L13.0571 22H10.9433C9.95376 22 9.08792 21.355 8.79631 20.4233L8.7509 20.2559L7.62133 15.3612C7.58905 15.2213 7.51729 15.0936 7.41458 14.9933C5.73517 13.353 4.8378 11.5302 4.75614 9.54966L4.75002 9.2514L4.75389 9.01209C4.88016 5.1188 8.07603 2.0014 12 2.0014ZM14.115 18.4994H9.88402L10.2125 19.9186C10.2832 20.2249 10.5357 20.4508 10.8401 20.4929L10.9433 20.5H13.0571C13.3713 20.5 13.6481 20.3048 13.7577 20.0178L13.7878 19.9188L14.115 18.4994ZM12 3.5014C8.89823 3.5014 6.37008 5.95742 6.25417 9.03085L6.25002 9.2514L6.25673 9.52841C6.33288 11.0918 7.05723 12.5475 8.46264 13.9201C8.72677 14.1781 8.92267 14.4964 9.03424 14.8464L9.08292 15.0239L9.53801 16.9994H14.461L14.9189 15.0232C15.0019 14.6639 15.1718 14.3314 15.4124 14.0543L15.5386 13.9205C16.9432 12.5479 17.6672 11.092 17.7433 9.52845L17.75 9.2514L17.7458 9.03085C17.6299 5.95742 15.1018 3.5014 12 3.5014Z"
      fill="currentColor"
    />
  </svg>
)

const BigCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
)

const BigClose = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
)
